import { UseMutationResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { changePassword } from './changePassword';
import { useTrackedMutation as useMutation } from '@ais-ui/performance-tracking';

type ChangePasswordArgs = {
  username: string;
  oldPassword: string;
  newPassword: string;
};

export const useChangePassword = (): UseMutationResult<
  unknown,
  Error,
  ChangePasswordArgs,
  null
> => {
  const { olSession } = useSession();

  return useMutation(
    ({ username, oldPassword, newPassword }: ChangePasswordArgs) => {
      return changePassword(olSession, username, oldPassword, newPassword);
    },
    {}
  );
};
